import { ReportsAppKind } from '@core/reports-types';
import { AppKind } from '@core/tellent-types';

export const tellentAppKindToReportsAppKind = (appKind: AppKind): ReportsAppKind | null => {
  switch (appKind) {
    case AppKind.KiwiHr:
      return ReportsAppKind.Hr;
    case AppKind.Recruitee:
      return ReportsAppKind.Ats;
    default:
      return null;
  }
};
